import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { del, get, post } from "../../services/api";
import { toast } from "react-toastify";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

const MarketingCampaign = () => {
    const token = localStorage.getItem("token");
  const user = localStorage.getItem("username");
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
const [bannerImages, setBannerImages] = useState([{ file: null, previewUrl: null }]);
const [termsPreview, setTermsPreview] = useState(null);
const [termsImageFile, setTermsImageFile] = useState(null);
const [assignResourceOptions, setAssignResourceOptions] = useState([]);
const [audienceOptions,setAudienceOptions] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const[EditId,setEditId] = useState(0);
  const [CompNO, setCompNo] = useState("");
  const [minEndDate, setMinEndDate] = useState(null);
  
 const fetchMarketing = async () => {
      try {
        const response = await get("MarketingCampaign/get-all");
        console.log("Marketing",response)
        setFilteredData(response); // assuming response is an array of facility objects
      } catch (error) {
        console.error("Error fetching facilities:", error);
      }
    };


  const fetchAudience = async () => {
    try {
      const res =  await get(`Audiences/all`);
      console.log(`Audience`, res) // <- update to your API
      setAudienceOptions(res || []);
    } catch (err) {
      console.error(`Failed fetching Audience`, err);
    }
  };
 const fetchResources = async () => {
     try {
       const res =  await get(`Facility/dropdowns/assignResource`);
       console.log(`Resources`, res) // <- update to your API
       setAssignResourceOptions(res || []);
     } catch (err) {
       console.error(`Failed fetching Resource`, err);
     }
   };

 const fetchCampaignId = async () => {
    try {
      const response = await get(`MarketingCampaign/latest-id`);
      
      const nextID = (response.latestCampaignId || 0) + 1;
      setValue("campaignNo", `M-${nextID}`);
    } catch (error) {
      console.error("Failed to fetch sales offer ID", error);
    }
  };
     

   useEffect(() => {
    fetchResources();
    fetchAudience();
    fetchMarketing();
    fetchCampaignId();
    }, []);



const handleBannerImageChange = (e, index) => {
  const file = e.target.files[0];
  if (file) {
    const updated = [...bannerImages];
    updated[index] = {
      file,
      previewUrl: URL.createObjectURL(file),
    };
    setBannerImages(updated);
  }
};
const addMoreBanner = () => {
  setBannerImages([...bannerImages, { file: null, previewUrl: null }]);
};

const handleTermsImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setTermsImageFile(file);
    setTermsPreview(URL.createObjectURL(file));
  }
};

const resetForm = () => {
  reset({
    campaignNo: "",
    campaignDescription: "",
    campaignDetail: "",
    terms: "",
    assignResource: [],
    audience: [],
    visibleOnSMS: false,
    visibleOnMobile: false,
    termsImage: null, // for React Hook Form
    startDate:"",
    endDate:""
  });
setEditId(0)
  // Reset file previews & file objects
  setTermsImageFile(null);
  setTermsPreview(null);
  setBannerImages([]);

};

 const saveData = async (data) => {
  if (!token) {
    console.error("Unauthorized");
    return;
  }
console.log("date",JSON.stringify(data))
  const formData = new FormData();
  formData.append("Id", EditId)
  formData.append("Description", data.campaignDescription);
  formData.append("Detail", data.campaignDetail);
  formData.append("Terms", data.terms);
  formData.append("CreatedOn", new Date().toISOString());
  formData.append("CreatedBy", user);
  formData.append("VisibleSMS", data.visibleOnSMS);
  formData.append("VisibleMobile", data.visibleOnMobile);
    formData.append("StartDate", data.startDate);
    formData.append("EndDate", data.endDate);

  // Terms image
  if (termsImageFile) {
    formData.append("TermsImage", termsImageFile);
  } else {
    console.warn("No terms image selected.");
  }

  // Banner images
  if (bannerImages.length > 0) {
    bannerImages.forEach((image, index) => {
      if (image.file) {
        formData.append("BannerImages", image.file);
      } else {
        console.warn(`Banner image at index ${index} has no file.`);
      }
    });
  } else {
    console.warn("No banner images selected.");
  }

  // ResourceIds
  if (Array.isArray(data.assignResource)) {
    data.assignResource.forEach((id) => {
      formData.append("ResourceIds", id);
    });
  } else {
    console.warn("assignResource is not an array.");
  }

  // AudienceIds
  if (Array.isArray(data.audience)) {
    data.audience.forEach((id) => {
      formData.append("AudienceIds", id);
    });
  } else {
    console.warn("audience is not an array.");
  }

  // Show FormData
  for (let pair of formData.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }

  try {
    const response = await post("MarketingCampaign/create", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    if (
      response.message === "Marketing campaign created successfully." ||
      response.status === 200
    ) {
      toast.success(`${EditId === 0 ? "Campaign saved successfully!" : "Campaign updated successfully!"}`);
      resetForm();
      fetchMarketing();
    } else {
      toast.error("Something went wrong!");
      console.error("Server Response:", response);
    }
  } catch (error) {
    console.error("API error:", error);
    toast.error("Error while saving campaign");
  }
};

  /* eslint-disable react-hooks/exhaustive-deps */
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "mrt-row-numbers",
        header: "Sr No.",
        enableColumnOrdering: false,
        enableEditing: false, 
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => row.index + 1,
      },
      {
        accessorKey: "description",
        header: "Name",
        // size: 150,
      },
      {
        accessorKey: "id", // Assuming ID is used for Code M-{id}
        header: "Code",
        // size: 100,
        Cell: ({ cell }) => `M-${cell.getValue()}`,
      },
      {
        accessorKey: "detail",
        header: "Description",
        // size: 200,
      },
      {
        accessorKey: "actions",
        header: "Action",
        size: 120,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="fas fa-pencil"></i>
            </button>
            <button
              type="button"
              className="btn p-0"
              onClick={() => handleDeleteClick(row.original.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ),
      },
    ],
    []
  );

  const exportToExcel = () => {
    const filteredDataExcel = filteredData.map((row, index) => ({
      "Sr No": index + 1,
      Name: row.description,
      Code: `M-${row.id}`,
      Description: row.detail,
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredDataExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MarketingCampaigns");
    XLSX.writeFile(workbook, "MarketingCampaigns.xlsx");
  };
  
  const loadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  };

  const exportToPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;

    const roleId = localStorage.getItem("roleId");
    const orgLogoPath = localStorage.getItem("organizationLogoPath");
    const centerLogoPath = localStorage.getItem("centerLogoPath");
    const orgLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${orgLogoPath}`;
    const centerLogo = `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages${centerLogoPath}`;

    let logoToUse = logo; // Default imported logo
    const sidebarLogoUrl =
      roleId == "2" ? orgLogo : roleId == "3" ? centerLogo : null;

    if (sidebarLogoUrl) {
      try {
        logoToUse = await loadImage(sidebarLogoUrl);
      } catch (error) {
        console.warn(
          "Failed to load sidebar logo, falling back to default.",
          error
        );
      }
    }

    // doc.addImage(logoToUse, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Marketing Campaigns";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter(
      (column) => column.accessorKey !== "actions" && column.accessorKey !== "mrt-row-numbers"
    );

    const headers = ["Sr No.", ...includedColumns.map((col) => col.header)];

    const bodyData = filteredData.map((row, index) => {
      return [
        index + 1,
        row.description,
        `M-${row.id}`,
        row.detail,
      ];
    });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [132, 23, 26],
        textColor: [255, 255, 255],
      },
    });

    doc.save("MarketingCampaigns.pdf");
  };
  
  const handleEditClick = async (row) => {
    console.log("row",JSON.stringify(row))
  try {
    // Set text fields
    setValue("campaignNo", `M-${row.id}` || "");
    setValue("campaignDescription", row.description || "");
    setValue("campaignDetail", row.detail || "");
    setValue("terms", row.terms || "");
    setValue("startDate", row.startDate ? row.startDate.split("T")[0] : "");
    setValue("endDate", row.endDate ? row.endDate.split("T")[0] : "");


    // Set checkboxes
    setValue("visibleOnSMS", row.visibleSMS || false);
    setValue("visibleOnMobile", row.visibleMobile || false);

    // Set Audience multi-select (expects array of IDs)
    setValue("audience", row.audienceIds || []);

    // Set Resources multi-select (expects array of IDs)
    setValue("assignResource", row.resourceIds || []);

    // Set Terms Image Preview (just for display)
    if (row.termsImageUrl) {
    
      setTermsPreview(`${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages/MarketPlace${row.termsImageUrl}`);
    }

    // Set Banner Images Preview (just for display)
    if (row.bannerImageUrls && row.bannerImageUrls.length > 0) {
      const formattedImages = row.bannerImageUrls.map((url) => ({
        preview: `${process.env.REACT_APP_API_URL}ExternalImages/MarketPlace${url}`,
        file: null, // since you only have preview, not file object
        existing: true,
      }));
      setBannerImages(formattedImages);
    }

    // Optional: Store editing row ID
    setEditId(row.id);

  } catch (error) {
    console.error("Error loading campaign data:", error);
  }
};

  
  
    const handleDeleteClick = async (rowId) => {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this level's detail?"
      );
  
      if (confirmDelete) {
     
        try {
          const response = await del(
            `MarketingCampaign/${rowId}?username=${user}`,
            
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            responseType: "text",
  
            }
          );
           
          console.log("response", response)
          if (response.message === "Campaign deleted successfully.") {
              fetchMarketing();
            toast.success(response.message || "Deleted!");
    
          
          } else {
            toast.error(response.message || "An error occurred while deleting.");
          }
        } catch (error) {
          console.error("Error deleting category:", error);
        }
      }
    };
  

  return (
    <div className="row g-3">
      {/* Left Side */}
      <div className="col-md-6">
        <div className="card h-100">
          <div className="card-body">
            <h4 className="mb-3 fs-8">Marketing Campaign</h4>
            <form className="row g-3" onSubmit={handleSubmit(saveData)}>
              {/* Campaign No */}
              <div className="col-md-6">
                <label className="form-label">
                  Campaign No 
                </label>
                <input
                readOnly
                  {...register("campaignNo", {
                   
                  })}
                  type="text"
                  className="form-control"
                />
                {errors.campaignNo && (
                  <small className="text-danger">
                    {errors.campaignNo.message}
                  </small>
                )}
              </div>

              {/* Campaign Description */}
              <div className="col-md-6">
                <label className="form-label">
                  Campaign Description <span className="text-danger fs-9">*</span>
                </label>
                <input
                  {...register("campaignDescription", {
                    required: "This field is required.",
                  })}
                  type="text"
                  className="form-control"
                />
                {errors.campaignDescription && (
                  <small className="text-danger">
                    {errors.campaignDescription.message}
                  </small>
                )}
              </div>

              {/* Campaign Detail */}
              <div className="col-md-12">
                <label className="form-label">
                  Campaign Detail <span className="text-danger fs-9">*</span>
                </label>
                <textarea
                  {...register("campaignDetail", {
                    required: "This field is required.",
                  })}
                  className="form-control"
                  rows={3}
                />
                {errors.campaignDetail && (
                  <small className="text-danger">
                    {errors.campaignDetail.message}
                  </small>
                )}
              </div>

              {/* Banner Images */}
            {/* Banner Images */}
{bannerImages.map((img, index) => (
  <div className="col-md-6" key={index}>
    <label className="form-label">
      Banner Image
      <span className="text-danger fs-9">*</span>
    </label>
    <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
      <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
        {img.previewUrl || img.preview ? (
          <img src={img.previewUrl || img.preview} alt="Preview" />
        ) : (
          <div>
            <span className="fas fa-image fs-3 text-light"></span>
          </div>
        )}
      </div>
      <input
        type="file"
        accept="image/*"
        className="form-control"
        {...register(`bannerImage_${index}`, {
          required: !(img.previewUrl || img.preview)
            ? "This field is required."
            : false,
        })}
        onChange={(e) => handleBannerImageChange(e, index)}
      />
    </div>
    {errors[`bannerImage_${index}`] && (
      <small className="text-danger">
        {errors[`bannerImage_${index}`].message}
      </small>
    )}
  </div>
))}

{/* + Add More Banner Button */}
<div className="col-md-6 d-flex align-items-end">
  <button type="button" className="btn btn-outline-primary btn-sm" onClick={addMoreBanner}>
    <i className="fas fa-plus me-1"></i>
  </button>
</div>


             
                <div className="col-md-6">
                    <label className="form-label">
                    Assign Resource <span className="text-danger fs-9">*</span>
                    </label>
                    <Controller
  name="assignResource"
  control={control}
  rules={{ required: "This field is required." }}
  render={({ field }) => (
    <Select
      {...field}
      isMulti
      options={assignResourceOptions.map((item) => ({
        value: item.id,
        label: item.value,
      }))}
      className="react-select-style"
      classNamePrefix="react-select-style-pref"
      onChange={(selectedOptions) => {
        const selectedIds = selectedOptions
          ? selectedOptions.map((option) => option.value)
          : [];
        field.onChange(selectedIds);
      }}
      value={assignResourceOptions
        .map((item) => ({
          value: item.id,
          label: item.value,
        }))
        .filter((option) =>
          field.value?.includes(option.value)
        )}
    />
  )}
/>

                    {errors.assignResource && (
                    <small className="text-danger">
                        {errors.assignResource.message}
                    </small>
                    )}
                </div>

               
                <div className="col-md-6">
                    <label className="form-label">
                    Audience <span className="text-danger fs-9">*</span>
                    </label>
                  <Controller
                    name="audience"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                        <Select
                        {...field}
                        isMulti
                        options={audienceOptions.map((item) => ({
                            value: item.id,
                            label: item.name,
                        }))}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        onChange={(selectedOptions) => {
                            const selectedIds = selectedOptions
                            ? selectedOptions.map((option) => option.value)
                            : [];
                            field.onChange(selectedIds);
                        }}
                        value={audienceOptions
                            .map((item) => ({
                            value: item.id,
                            label: item.name,
                            }))
                            .filter((option) =>
                            field.value?.includes(option.value)
                            )}
                        />
                    )}
                    />

                                        {errors.audience && (
                                        <small className="text-danger">
                                            {errors.audience.message}
                                        </small>
                                        )}
                                    </div>
                                      <div className="col-md-6">
    <label className="form-label">
      Campaign Start Date <span className="text-danger fs-9">*</span>
    </label>
    <input
      type="date"
      className="form-control"
      {...register("startDate", {
        required: "Start Date is required",
      })}
      min={new Date().toISOString().split("T")[0]}
      onChange={(e) => {
        setValue("startDate", e.target.value);
        setMinEndDate(e.target.value); // custom state to update end date min
        setValue("endDate", "")
      }}
    />
    {errors.startDate && (
      <small className="text-danger">{errors.startDate.message}</small>
    )}
  </div>

  {/* Campaign End Date */}
  <div className="col-md-6">
    <label className="form-label">
      Campaign End Date <span className="text-danger fs-9">*</span>
    </label>
    <input
      type="date"
      className="form-control"
      {...register("endDate", {
        required: "End Date is required",
      })}
      min={minEndDate || new Date().toISOString().split("T")[0]}
    />
    {errors.endDate && (
      <small className="text-danger">{errors.endDate.message}</small>
    )}
  </div>

                                {/* Terms & Conditions */}
                                <div className="col-md-12">
                                    <label className="form-label">
                                    Terms & Conditions <span className="text-danger fs-9">*</span>
                                    </label>
                                    <textarea
                                    {...register("terms", {
                                        required: "This field is required.",
                                    })}
                                    className="form-control"
                                    rows={3}
                                    />
                                    {errors.terms && (
                                    <small className="text-danger">
                                        {errors.terms.message}
                                    </small>
                                    )}
                                </div>

                            
                                    <div className="col-md-6">
                    <label className="form-label">
                        Terms & Conditions Image
                        <span className="text-danger fs-9">*</span>
                    </label>
                    <div className="image-uploader-wrapper-2 d-flex flex-column align-items-center">
                        <div className="image-preview d-flex justify-content-center align-items-center flex-shrink-0 mb-2 mt-1">
                        {termsPreview ? (
                            <img src={termsPreview} alt="Preview" />
                            
                        ) : (
                            <div>
                            <span className="fas fa-image fs-3 text-light"></span>
                            </div>
                        )}
                        </div>
                        <input
                        {...register("termsImage", {
                            required: !termsPreview ? "This field is required." : false,
                        })}
                        type="file"
                        accept="image/*"
                        className="form-control"
                        onChange={handleTermsImageChange}
                        />
                    </div>
                    {errors.termsImage && (
                        <small className="text-danger">{errors.termsImage.message}</small>
                    )}
                    </div>



              {/* Visibility Options */}
              <div className="col-md-12">
                <label className="form-label">Visible On</label>
                <div className="form-check">
                  <input
                    type="checkbox"
                    {...register("visibleOnSMS")}
                    className="form-check-input"
                    id="sms"
                  />
                  <label htmlFor="sms" className="form-check-label">
                    Portal
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="checkbox"
                    {...register("visibleOnMobile")}
                    className="form-check-input"
                    id="mobile"
                  />
                  <label htmlFor="mobile" className="form-check-label">
                    Mobile
                  </label>
                </div>
              </div>

              {/* Save Button */}
              <div className="col-12 mt-3">
                <button type="submit" className="btn btn-primary btn-sm">
                  {EditId === 0 ? "Save" : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Right Side (empty for now) */}
      <div className="col-md-6">
  <div className="card h-100">
    <div className="card-body">
      {/* Data Table */}
      <CustomDatatableGrid
        columns={columns}
        data={filteredData}
        onExportExcel={exportToExcel}
        onExportPDF={exportToPDF}
        initialState={{
          columnPinning: { right: ["actions"] },
        }}
      />
    </div>
  </div>
</div>
    </div>
  );
};

export default MarketingCampaign;
